module.exports = __webpack_public_path__ + "static/media/pdf.9fd4010a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/think/pdf.svg
// module id = 1225
// module chunks = 0